import { render } from "./CurrentlyServing.vue?vue&type=template&id=e9fcdfbe&scoped=true"
import script from "./CurrentlyServing.vue?vue&type=script&lang=js"
export * from "./CurrentlyServing.vue?vue&type=script&lang=js"

import "./CurrentlyServing.vue?vue&type=style&index=0&id=e9fcdfbe&lang=scss&scoped=true"

import exportComponent from "../../../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9fcdfbe"]])

export default __exports__